import { CardAssociacoes } from '@/global/components/CardAssociacoes'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import ContentGuide from 'global/guides/ContentGuide/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import { useState } from 'react'
import { useQuery } from 'react-query'
import { centroCusto } from 'service/api'
import { AdicionarFuncionariosCentroCusto } from './modals/AdicionarFuncionarios'
import { DesassociarFuncionarioCentroCusto } from './modals/DesassociarFuncionario'

interface Props {
    centroCustoId: number
}

/** Funcionários vinculados ao centro de custo, com adicionar e remover. */
export function FuncionariosAssociadosCentroCusto({ centroCustoId }: Props) {
    const [isAdicionarAberto, setIsAdicionarAberto] = useState(false)
    const canEditar = hasPermission(['update', 'Funcionários'])
    const { data, isLoading } = useQuery(['centroCusto', centroCustoId], () =>
        centroCusto.getById(centroCustoId),
    )
    const vinculos = data?.FuncionarioCentroCusto ?? []

    return [
        <CardAssociacoes
            key="lista"
            titulo="Funcionários associados"
            tituloAdicionar="Adicionar funcionários"
            onAdicionar={
                canEditar ? () => setIsAdicionarAberto(true) : undefined
            }
        >
            <div className="min-h-96 w-full flex-1">
                <ContentGuide.DataGrid
                    loading={isLoading}
                    density="compact"
                    className="*:border-none"
                    columns={[
                        {
                            field: 'Funcionario',
                            headerName: 'Nome',
                            flex: 1,
                            valueGetter: ({ value }) => value.nome,
                        },
                        ...(canEditar
                            ? [
                                  {
                                      ...optionsColumn,
                                      field: '__desassociar',
                                      renderCell:
                                          DesassociarFuncionarioCentroCusto,
                                  },
                              ]
                            : []),
                    ]}
                    rows={vinculos}
                    ToolbarProps={{ hideToolbar: true }}
                    hideFooter
                />
            </div>
        </CardAssociacoes>,
        <AdicionarFuncionariosCentroCusto
            key="adicionar"
            centroCustoId={centroCustoId}
            funcionarioIdsAssociados={vinculos.map(item => item.funcionarioId)}
            open={isAdicionarAberto}
            onClose={() => setIsAdicionarAberto(false)}
        />,
    ]
}
